// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_SELL_EXP_POPUP_BUTTON_LATER = "Te\u010f ne";
export const BZ2_SELL_EXP_POPUP_BUTTON_WRITE = "Napsat zku\u0161enost";
export const BZ2_SELL_EXP_POPUP_TEXT = "Pomoz ostatn\u00edm a napi\u0161, co ti na n\u011bm vyhovovalo i co ne.";
export const BZ2_SELL_EXP_POPUP_TITLE = "Zn\u00e1\u0161 tento produkt z vlastn\u00ed zku\u0161enosti?";
